/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Type of meeting.
 */
export type MeetingType = (typeof MeetingType)[keyof typeof MeetingType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeetingType = {
  interview: 'interview',
  intake: 'intake',
  sales: 'sales',
  staffing_discovery: 'staffing_discovery',
  other: 'other',
} as const;
